export function getNotification(state) {
  return state.notification;
}



// WEBPACK FOOTER //
// ./src/notification/selectors.js